import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Image.png';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-r from-slate-900 via-gray-900 to-black text-white overflow-hidden border-t border-white/10">

      {/* Glow Effects */}
      <div className="absolute top-0 left-0 w-48 h-48 bg-cyan-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-48 h-48 bg-pink-500/10 rounded-full blur-3xl"></div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">

        {/* TOP SECTION - Equal spacing between 3 sections */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          
          {/* LEFT - Logo & Brand */}
          <div className="flex items-center gap-3 md:w-1/3 justify-start">
            <div className="group relative">
              <div className="absolute inset-0 bg-cyan-400 blur-md opacity-40 group-hover:opacity-70 transition-all duration-300 rounded-lg"></div>
              <div className="relative w-10 h-10 rounded-lg overflow-hidden border border-white/20 shadow-xl bg-white">
                <img
                  src={logo}
                  alt="Harshal Jobs"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            </div>
            <div>
              <h2 className="text-xl font-extrabold tracking-wide bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                Harshal Jobs
              </h2>
              <p className="text-xs text-gray-300">
                Architecting career transitions with high-fidelity intelligence 🚀
              </p>
            </div>
          </div>

          {/* CENTER - Email (Now Centered) */}
          <div className="md:w-1/3 flex justify-center">
            <a
              href="mailto:support@harshaljobs.com"
              className="flex items-center gap-1.5 text-xs text-gray-300 hover:text-cyan-300 transition-all duration-300 px-2"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              support@harshaljobs.com
            </a>
          </div>

          {/* RIGHT - Social Links */}
          <div className="flex items-center justify-end gap-2 md:w-1/3">
            {/* Instagram */}
            <a
              href="https://www.instagram.com/harshaljobs/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full bg-white/10 hover:bg-pink-600 flex items-center justify-center border border-white/10 hover:scale-110 transition-all duration-300"
            >
              <svg
                className="w-3.5 h-3.5 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 1.8h8.5a3.95 3.95 0 013.95 3.95v8.5a3.95 3.95 0 01-3.95 3.95h-8.5a3.95 3.95 0 01-3.95-3.95v-8.5A3.95 3.95 0 017.75 3.8zm8.95 1.35a1.05 1.05 0 100 2.1 1.05 1.05 0 000-2.1zM12 6.86A5.14 5.14 0 106 12a5.14 5.14 0 006-5.14zm0 1.8A3.34 3.34 0 118.66 12 3.34 3.34 0 0112 8.66z" />
              </svg>
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/harshaljobs?_l=en_US"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full bg-white/10 hover:bg-blue-700 flex items-center justify-center border border-white/10 hover:scale-110 transition-all duration-300"
            >
              <svg
                className="w-3.5 h-3.5 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M4.98 3.5C4.98 4.604 4.104 5.5 3 5.5S1.02 4.604 1.02 3.5 1.896 1.5 3 1.5s1.98.896 1.98 2zM1.5 8h3V22h-3V8zm7 0h2.879v1.91h.041c.401-.761 1.379-1.562 2.839-1.562 3.037 0 3.6 2 3.6 4.59V22h-3v-6.5c0-1.55-.028-3.54-2.158-3.54-2.16 0-2.49 1.688-2.49 3.43V22h-3V8z" />
              </svg>
            </a>
          </div>
        </div>

        {/* LINKS SECTION */}
        <div className="flex flex-wrap items-center justify-center gap-2 mt-4">
          <Link
            to="/privacy"
            className="px-3 py-1.5 rounded-full bg-white/5 hover:bg-cyan-500/20 border border-white/10 hover:border-cyan-400 transition-all duration-300 text-xs font-medium hover:text-cyan-300"
          >
            Privacy
          </Link>
          <Link
            to="/terms"
            className="px-3 py-1.5 rounded-full bg-white/5 hover:bg-cyan-500/20 border border-white/10 hover:border-cyan-400 transition-all duration-300 text-xs font-medium hover:text-cyan-300"
          >
            Terms
          </Link>
          <Link
            to="/disclaimer"
            className="px-3 py-1.5 rounded-full bg-white/5 hover:bg-cyan-500/20 border border-white/10 hover:border-cyan-400 transition-all duration-300 text-xs font-medium hover:text-cyan-300"
          >
            Disclaimer
          </Link>
          <Link
            to="/delete-account"
            className="px-3 py-1.5 rounded-full bg-white/5 hover:bg-red-500/20 border border-white/10 hover:border-red-400 transition-all duration-300 text-xs font-medium hover:text-red-300"
          >
            Delete Account
          </Link>
        </div>

        {/* BOTTOM */}
        <div className="border-t border-white/10 mt-4 pt-3 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-gray-400 text-xs text-center">
            © {new Date().getFullYear()} Harshal Jobs. All Rights Reserved.
          </p>
          <p className="text-gray-500 text-[11px] tracking-wide text-center">
            Empowering elite talent pipelines globally
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;